const vi = {
  CREATE: 'Tạo mới',
  SAVE: 'Save',
  UNLOCK_MORE_LESSONS: 'Xem thêm các bài học',
  USER_PROFILE: {
    USER_PASSWORD: 'Mật khẩu người dùng',
    UPDATE_PASSWORD_HERE: 'Cập nhật mật khẩu người dùng tại đây',
    USER_PROFILE: 'Thông tin người dùng',
    UPDATE_USER_PROFILE: 'Cập nhật thống tin người dùng tại đây',
  },
  NOTIFICATION: {
    TITLE: 'Thông báo',
    MARK_AS_READ: 'Đánh dấu tất cả đã đọc',
    NO_NOTI: 'Không có thông báo nào',
    LOAD_MORE: 'Tải thêm',
    VIEW_ALL: 'Xem tất cả',
    UNREAD: 'Chưa đọc',
    DETAIL_TITLE: 'Chi tiết thông báo',
    DETAIL_BACK: 'Quay lại danh sách',
    DETAIL_NOT_FOUND: 'Không tìm thấy thông báo này.',
    DETAIL_NO_BODY: 'Không có nội dung chi tiết.',
  },
  CORPORATE_CUSTOMER: {
    TITLE: 'Khách hàng doanh nghiệp',
  },
  CONSULTATION_FORM: {
    TITLE: 'Trở thành Full Stack Data Scientist ngày hôm nay',
    FIELDS: {
      NAME: {
        LABEL: 'Tên',
        PLACEHOLDER: 'Nhập tên của bạn',
        ERROR: 'Tên phải có ít nhất 2 ký tự',
      },
      EMAIL: {
        LABEL: 'Email',
        PLACEHOLDER: 'Email của bạn',
        ERROR: 'Email không hợp lệ',
      },
      PHONE: {
        LABEL: 'Số điện thoại',
        PLACEHOLDER: 'Nhập số điện thoại',
        ERROR: 'Số điện thoại phải có 10 chữ số',
      },
      MESSAGE: {
        LABEL: 'Lời nhắn',
        PLACEHOLDER: 'Nhập lời nhắn của bạn',
        ERROR: 'Lời nhắn phải có ít nhất 10 ký tự',
      },
    },
    SUBMIT: {
      BUTTON: 'Nhận tư vấn',
      SENDING: 'Đang gửi...',
      SUCCESS: 'Cảm ơn bạn! Chúng tôi sẽ liên hệ với bạn sớm.',
      ERROR: 'Có lỗi xảy ra. Vui lòng thử lại sau.',
    },
    DIVIDER: 'hoặc',
    FACEBOOK: 'Liên hệ qua Facebook',
  },
  COURSE_MODULE: {
    TAGS: {
      SHOW_MORE: 'Xem thêm',
      SHOW_LESS: 'Thu gọn',
      COUNT_LABEL: (count: number) => `+Xem thêm ${count}`,
    },
    OVERVIEW: 'Tổng quan về khóa học',
    INFORMATION: {
      TITLE: 'Thông tin',
      FINAL_PROJECT: 'Final project',
      LAB_NUMBER: 'Số lượng bài lab',
      SCHEDULE: 'Lịch học',
      TOTAL_DURATION: 'Thời gian học',
      PROJECT_DURATION: 'Thời gian làm đồ án',
      ACCESS_DURATION: 'Thời gian truy cập',
      FORMAT: 'Hình thức khoá học',
    },
    FORMAT: {
      TITLE: 'Hình thức',
      LEARNING_FORMAT: {
        TITLE: 'Hình thức học',
        PRE_RECORDED: 'Pre-recorded videos',
        ONLINE: 'Học online qua Zoom (Học viên có thể xem lại recording của live)',
        SUPPORT: 'Hỗ trợ debug qua Discord hoặc call trực tiếp qua Zoom',
      },
      PROMOTION: {
        TITLE: 'Ưu đãi',
        DISCOUNT: 'Ưu đãi giảm 15% học phí',
      },
    },
  },
  FEATURE_GLASS: {
    TITLE: 'Tại sao nên chọn FSDS?',
    CARDS: {
      PIONEER: {
        TITLE: 'Nơi tiên phong đào tạo Full Stack Data Scientist',
        DESCRIPTION:
          'Chương trình duy nhất tại Việt Nam cung cấp kiến thức toàn diện để trở thành một Full Stack Data Scientist, từ Machine Learning, Data Analytics, Engineering cho tới Domain Knowledge.',
      },
      PRACTICAL: {
        TITLE: 'Kiến thức thực chiến – Bám sát nhu cầu doanh nghiệp',
        DESCRIPTION:
          'Học gắn liền với thực hành, kết hợp lý thuyết, các bài lab chuyên sâu cho từng bài giảng và đồ án cuối kỳ mô phỏng thực tế.',
      },
      DEMO_DAY: {
        TITLE: 'Demo Day – Chữa đồ án & Định hướng sự nghiệp 1-1',
        DESCRIPTION:
          'Trình bày đồ án trước hội đồng chuyên gia, nhận feedback trực tiếp và tư vấn lộ trình phát triển cá nhân từ giảng viên và mentor.',
      },
      BEYOND_ALGO: {
        TITLE: 'Học Data Science vượt ra ngoài thuật toán',
        DESCRIPTION:
          'Giáo trình được thiết kế tích hợp cả kiến thức chuyên ngành (Domain Knowledge), giúp học viên vận dụng AI/ML một cách thực tiễn và hiệu quả trong từng lĩnh vực cụ thể.',
      },
      INSTRUCTORS: {
        TITLE: 'Đội ngũ giảng viên chuyên nghiệp từ Big Tech',
        DESCRIPTION:
          'Học hỏi từ các chuyên gia có kiến thức sâu rộng và nhiều kinh nghiệm thực tế tại các công ty hàng đầu ở Việt Nam và trên thế giới.',
      },
      COMMUNITY: {
        TITLE: 'Cộng đồng FSDS – Kết nối & phát triển sự nghiệp',
        DESCRIPTION:
          'Gia nhập network FSDS để học hỏi từ những chuyên gia, cập nhật nhanh nhất các cơ hội việc làm hấp dẫn, bao gồm cả những công việc không công khai.',
      },
    },
  },
  BILLING: {
    SKELETON: {
      TITLE: 'Thanh toán',
      SUBTITLE: 'Quản lý thông tin thanh toán và hóa đơn của bạn.',
      PLAN: 'Hàng tháng',
    },
    HISTORY: {
      TITLE: 'Lịch sử thanh toán',
      ERROR: 'Lỗi khi tải dữ liệu',
    },
    DATA: {
      NO_INVOICE: {
        TITLE: 'Không tìm thấy hóa đơn',
        DESCRIPTION: 'Hiện tại chưa có hóa đơn nào. Bạn có thể mua khóa học để xem hóa đơn tại đây.',
      },
      ERROR: {
        TITLE: 'Lỗi khi tải thông tin thanh toán',
        DEFAULT_MESSAGE: 'Không thể tải thông tin thanh toán. Vui lòng thử lại sau.',
      },
      NO_DATA: 'Không có thông tin thanh toán.',
      SECTION: {
        TITLE: 'Lần thanh toán mới nhất',
        SUBTITLE: 'Quản lý đăng ký và thông tin thanh toán của bạn.',
        POPULAR_PLAN: 'Gói phổ biến nhất cho cá nhân.',
        SUBSCRIPTION_STATUS: 'Trạng thái đăng ký',
        TIME_REMAINING: 'Còn lại {days} ngày {hours} giờ {minutes} phút',
        RENEWAL_MESSAGE: 'Đăng ký của bạn sẽ {action} vào ngày {date}',
      },
    },
    PAGE: {
      TITLE: 'Thanh toán của bạn',
      SUBTITLE: 'Quản lý thông tin thanh toán và hóa đơn của bạn.',
      LABEL: 'Gói & Thanh toán',
      GO_TO_PRICING: 'Xem bảng giá',
    },
    CANCEL_SUBSCRIPTION: {
      BUTTON: 'Hủy đăng ký',
      CONFIRM_TITLE: 'Hủy đăng ký',
      CONFIRM_DESCRIPTION: 'Bạn có chắc chắn muốn hủy đăng ký không? Hành động này không thể hoàn tác.',
      REASON_LABEL: 'Lý do hủy (Tùy chọn)',
      REASON_PLACEHOLDER: 'Cho chúng tôi biết lý do bạn hủy...',
      CONFIRM_BUTTON: 'Có, hủy đăng ký',
      CANCEL_BUTTON: 'Không, giữ đăng ký của tôi',
      SUCCESS_MESSAGE: 'Đăng ký của bạn đã được hủy thành công.',
      ERROR_MESSAGE: 'Không thể hủy đăng ký. Vui lòng thử lại.',
    },
  },
  CHECKOUT: {
    TITLE: 'Thanh toán',
    ORDER_SUMMARY: 'Tóm tắt đơn hàng',
    SUBTOTAL: 'Tạm tính',
    TOTAL: 'Tổng cộng',
    PAYMENT_METHOD: 'Phương thức thanh toán',
    PROCESSING: 'Đang xử lý...',
    PAYMENT_SUCCESS: 'Thanh toán thành công!',
    PAYMENT_ERROR: 'Có lỗi xảy ra khi xử lý thanh toán của bạn. Vui lòng thử lại.',
    SUCCESS_TOAST_TITLE: 'Thành công',
    SUCCESS_PAGE: {
      TITLE: 'Thanh toán thành công',
      HEADING: 'Thanh toán thành công!',
      MESSAGE:
        'Cảm ơn bạn đã mua hàng. Thanh toán của bạn đã được xử lý thành công. Vui lòng kiểm tra email của bạn để xem hướng dẫn chi tiết',
      RETURN_HOME: 'Trở về trang chủ',
      ACCESS_COURSES: 'Truy cập khóa học',
    },
    FAILED_PAGE: {
      TITLE: 'Thanh toán thất bại',
      HEADING: 'Thanh toán thất bại',
      TRY_AGAIN: 'Thử lại',
      RETURN_HOME: 'Trở về trang chủ',
    },
    FREE_ITEM: 'Free',
    DISCOUNT_FIXED: 'Discount fixed',
  },
  FOOTER: {
    SECTIONS: {
      COURSES: 'Khóa học',
      COMMUNITY: 'Cộng đồng',
      PLAN: 'Kế hoạch',
    },
    ITEMS: {
      MLOPS: 'MLOps',
      MLOPS_1: 'MLOps 1',
      MLOPS_2: 'MLOps 2',
      MLOPS_3: 'MLOps 3',
      MLOPS_4: 'MLOps 4',
      IGDS: 'IGDS',
      CDA: 'CDA',
      BLOGS: 'Blogs',
      WEBINARS: 'Webinars',
      SURVEY: 'Khảo sát',
      PRICING: 'Bảng giá',
      HALL_OF_FAME: 'Vinh danh',
    },
    COPYRIGHT: '© {year} {siteName}.',
  },
  HALL_OF_FAME_SECTION: {
    TITLE: 'Hall of Fame',
    DESCRIPTION:
      'Nền tảng ghi dấu bước tiến của học viên, nơi lưu giữ những thành quả đáng tự hào, offers hấp dẫn và đồ án tâm huyết.',
    VIEW_ALL: 'Xem tất cả',
  },
  SURVEY: {
    HERO: {
      TITLE: 'Khảo sát khóa học',
      DESCRIPTION:
        'Lộ trình độc quyền kết hợp <b>Business Intelligence</b> và <b>Machine Learning</b>. Trang bị kiến thức và kỹ năng cần thiết để trở thành chuyên gia phân tích dữ liệu với <b>tư duy thuật toán</b>, <b>khả năng kể chuyện dữ liệu</b>, và <b>trình độ kỹ thuật</b> trong các lĩnh vực tài chính, tiếp thị.',
      GET_CONSULTATION: 'Nhận Tư Vấn',
    },
    TITLE: 'Khảo sát khóa học',
    DESCRIPTION: 'Giúp chúng tôi cải thiện khóa học bằng cách chia sẻ phản hồi của bạn',
    FORM: {
      HEADER: {
        TITLE: 'Khảo sát',
        SUBTITLE: 'Chúng tôi rất mong được lắng nghe từ bạn. Vui lòng điền vào biểu mẫu này.',
      },
      LABELS: {
        COURSE: 'Khóa học',
        COURSE_PLACEHOLDER: 'Nhập tên khóa học',
        REVIEW: 'Đánh giá',
        REVIEW_PLACEHOLDER: 'Viết đánh giá của bạn tại đây',
        EMAIL: 'Email',
        EMAIL_PLACEHOLDER: 'Nhập email của bạn',
        IMPROVEMENT: 'Góp ý cải thiện (Tùy chọn)',
        IMPROVEMENT_PLACEHOLDER: 'Đề xuất cải thiện',
        IMPROVEMENT_DESCRIPTION: 'Tùy chọn: Đề xuất cải thiện cho khóa học',
      },
      SUBMIT: 'Gửi khảo sát',
      SUCCESS: {
        TITLE: 'Gửi khảo sát thành công',
        DESCRIPTION: 'Cảm ơn bạn đã gửi phản hồi!',
      },
      ERROR: {
        TITLE: 'Lỗi khi gửi khảo sát',
        DESCRIPTION: 'Đã xảy ra lỗi khi gửi khảo sát của bạn. Vui lòng thử lại.',
      },
      VALIDATION: {
        COURSE_REQUIRED: 'Tên khóa học là bắt buộc',
        REVIEW_MIN_LENGTH: 'Đánh giá phải có ít nhất 10 ký tự',
        EMAIL_INVALID: 'Địa chỉ email không hợp lệ',
      },
      NAME: 'Họ và tên',
      EMAIL: 'Địa chỉ email',
      COURSE: 'Tên khóa học',
      RATING: 'Đánh giá khóa học',
      FEEDBACK: 'Phản hồi của bạn',
    },
  },
  HEADER: {
    COURSE: 'Courses',
    HALL_OF_FAME: 'Hall of Fame',
    LOGIN: 'Sign In',
    STUDENT_THOUGHTS: 'Students thoughts',
    INSTRUCTORS: 'Instructors',
    FAQ: 'FAQ',
    CAREER: 'Career',
  },
  MAIN: {
    INTRODUCTION: {
      HEADING_1: '💻 Học Data Science theo góc nhìn Engineering',
      HEADING_2: 'HỌC, KẾT NỐI <br /> PHÁT TRIỂN SỰ NGHIỆP',
      HEADING_3:
        'AI-powered e-learning platform đầu tiên dành cho Data & AI, kết hợp học tập, kết nối và hỗ trợ nghề nghiệp',
      HEADING_4: 'Nhận tư vấn ngay',
      HEADING_5: 'Mua ngay',
      HEADING_6: 'Vào lớp',
      HEADING_7: 'Coming soon',
    },
    BODY: {
      HEADING_1: 'Khoá học của FSDS',
      HEADING_2: 'Bắt đầu một sự nghiệp mới chỉ trong vòng 6 tháng.',
      COURSE: {
        DETAIL: 'Xem chi tiết',
        DETAIL_COURSE: 'Xem chi tiết giáo trình và học phí',
      },
      COURSE_VI: {
        1: {
          TITLE: 'Khoá học MLOps',
          DESCRIPTION:
            'Học cách <b>tự động hóa</b>, <b>triển khai</b> và <b>giám sát</b> các mô hình học máy ở quy mô lớn bằng cách sử dụng các <b>công cụ</b> và <b>framework</b> hiện đại.',
        },
        2: {
          TITLE: 'Khoá học Comprehensive Data Analytics (CDA)',
          DESCRIPTION:
            'Phát triển kỹ năng về <b>business intelligence</b>, <b>predictive analytics</b> và <b>data storytelling</b>.',
        },
        3: {
          TITLE: 'Khoá học Industrial-Grade Data Science (IGDS)',
          DESCRIPTION: 'Đào sâu vào <b>học máy</b>, <b>học sâu</b>, và <b>ứng dụng thực tiễn</b> trong từng lĩnh vực.',
        },
      },
      COURSE_EN: {
        1: {
          TITLE: 'Khoá học MLOps 1',
          DESCRIPTION:
            'Học cách <b>tự động hóa</b>, <b>triển khai</b> và <b>giám sát</b> các mô hình học máy ở quy mô lớn bằng cách sử dụng các <b>công cụ</b> và <b>framework</b> hiện đại.',
        },
        2: {
          TITLE: 'Khoá học MLOps 2',
          DESCRIPTION:
            'Học cách <b>tự động hóa</b>, <b>triển khai</b> và <b>giám sát</b> các mô hình học máy ở quy mô lớn bằng cách sử dụng các <b>công cụ</b> và <b>framework</b> hiện đại.',
        },
        3: {
          TITLE: 'Khoá học MLOps 3',
          DESCRIPTION:
            'Học cách <b>tự động hóa</b>, <b>triển khai</b> và <b>giám sát</b> các mô hình học máy ở quy mô lớn bằng cách sử dụng các <b>công cụ</b> và <b>framework</b> hiện đại.',
        },
        4: {
          TITLE: 'Khoá học MLOps 4',
          DESCRIPTION:
            'Học cách <b>tự động hóa</b>, <b>triển khai</b> và <b>giám sát</b> các mô hình học máy ở quy mô lớn bằng cách sử dụng các <b>công cụ</b> và <b>framework</b> hiện đại.',
        },
        DETAIL: 'Xem chi tiết',
      },
      HEADING_3: 'Tại sao nên chọn FSDS?',
      FEATURES: {
        1: {
          TITLE: 'Thuật toán',
          DESCRIPTION: 'Xây dựng nền tảng thuật toán vững chắc từ cơ bản đến nâng cao.',
        },
        2: {
          TITLE: 'Tư duy phân tích',
          DESCRIPTION: 'Phát triển tư duy phân tích và giải quyết vấn đề thực tế từ các chuyên gia trong ngành.',
        },
        3: {
          TITLE: 'Ứng dụng thực tế',
          DESCRIPTION:
            'Ứng dụng với dataset và bài toán thực tế từ các lĩnh vực ngân hàng, thương mại điện tử, giao thông vận tải, xuất bản, marketing.',
        },
        4: {
          TITLE: 'Kỹ thuật',
          DESCRIPTION: 'Xây dựng và triển khai hệ thống và hạ tầng kỹ thuật hiệu quả, chịu tải lớn.',
        },
      },
      HEADING_4: 'Học lý thuyết đi đôi với thực hành!',
      HEADING_5:
        'FSDS hiểu rằng lý thuyết vững chắc là nền tảng, nhưng để trở thành một Data Scientist thực thụ, học viên cần trực tiếp triển khai các dự án thực tế, được chấm, sửa bài và nhận sự hướng dẫn từ các chuyên gia trong lĩnh vực.',
      HEADING_6: 'Học viên nói gì về FSDS',
      FEEDBACK_BUTTON: {
        EXPAND: '❤️ Xem thêm',
        COLLAPSE: '❤️ Thu gọn',
      },
      HEADING_7: 'Học viên đến từ đâu?',
      HEADING_8: 'Bài giảng mẫu',
      HEADING_9: 'Trở thành Full Stack Data Scientist ngay hôm nay',
      CONTACT_BUTTON: 'Nhận Tư Vấn',
      HEADING_10: 'Đội ngũ giảng viên',
      HEADING_11: 'Câu hỏi thường gặp',
      FAQ: {
        1: {
          QUESTION: 'Tôi sẽ nhận được chứng chỉ sau khi hoàn thành khóa học chứ?',
          ANSWER:
            'Có, bạn sẽ nhận được chứng chỉ sau khi hoàn thành đồ án tốt nghiệp, được cấp một lần, có giá trị suốt đời và không bao giờ hết hạn. Xin lưu ý rằng chứng chỉ chỉ được cấp khi đồ án được giảng viên chấp thuận.',
        },
        2: {
          QUESTION: 'Tôi có thể chia sẻ hay tải nội dung khóa học không?',
          ANSWER:
            'Nội dung do Full Stack Data Science sở hữu chỉ có thể được sử dụng cho mục đích cá nhân, phi thương mại. Chia sẻ nội dung với người khác là không được phép và bất hợp pháp.',
        },
        3: {
          QUESTION: 'Tôi muốn biết yêu cầu cấu hình máy để học là gì?',
          ANSWER:
            'Để tham gia chương trình học một cách thuận lợi nhất, chúng tôi khuyến khích học viên sử dụng máy tính có ít nhất 16GB RAM và 150GB dung lượng ổ cứng (nên sử dụng SSD). Trong suốt quá trình học, chúng ta sẽ sử dụng hệ điều hành Ubuntu 22.04; tuy nhiên, phiên bản 20.04 cũng là lựa chọn hợp lý nếu đã cài đặt sẵn. Đối với các học viên sử dụng Macbook, không cần cài đặt Ubuntu, tuy nhiên nếu có máy tính chạy Ubuntu sẽ là lựa chọn tốt nhất. Lưu ý rằng nên tránh sử dụng các vi xử lý quá cũ (ví dụ như chip Intel i3 sản xuất cách đây 10 năm) để đảm bảo máy tính hoạt động mượt mà và hiệu quả trong suốt khóa học.',
        },
        4: {
          QUESTION: 'FSDS có yêu cầu về toán học không?',
          ANSWER:
            'Không. Tất cả các kiến thức toán học cần thiết đều đã được tích hợp trong các lớp FSDS, giúp học viên nắm bắt và hiểu rõ các thuật toán cũng như ứng dụng của chúng ngay lập tức, mà không cần tham gia thêm bất kỳ khóa học Toán nào bên ngoài.',
        },
      },
    },
    ROADMAP: {
      HEADING: "Full Stack Data Scientist Roadmap <br /> bởi <span class='text-primary'>FSDS</span>",
    },
    COURSE: {
      HEADING: 'Khóa học của FSDS',
      TOTAL_DURATION: 'Tổng thời gian học',
      PROJECT_DURATION: 'Tổng thời gian làm đồ án',
      ACCESS_DURATION: 'Thời gian truy cập',
      MONTH: 'tháng',
      DETAIL: {
        MLOPS_1: {
          TITLE: 'Xây dựng hệ thống ML hiệu quả',
          TITLE_2: 'Yếu tố cần thiết để chinh phục <br /> Data Science',
          BODY: {
            TITLE: 'Dự án và bài tập chuyên sâu',
            DESCRIPTION: 'Mỗi bài tập, bài kiểm tra và dự án được thiết kế xoay quanh các bài toán thực tế.',
            DESCRIPTION_1: 'Xây dựng OCR Deployment với Ansible và Terraform',
            DESCRIPTION_2: 'Phát triển pipeline dữ liệu streaming với Flink',
            DESCRIPTION_3: 'Tối ưu hóa inference server với KServe',
            DESCRIPTION_4: 'Quản lý chất lượng dữ liệu với Great Expectations',
          },
          VIEW_LECTURE: 'Xem giáo trình',
          DESCRIPTION:
            'Trở thành chuyên gia MLOps với <b>tư duy kỹ thuật</b>, <b>triển khai mô hình</b> và <b>xây dựng hệ thống ML bền vững</b> trên các nền tảng tiên tiến như <b>Kubernetes</b>, <b>Terraform</b>, <b>Kubeflow</b> và <b>Airflow</b>.',
        },
      },
    },
    INSTRUCTORS: {
      JOB_TITLE: 'Giảng viên - Khóa',
    },
  },
  COURSE: {
    MY_COURSE: 'Lớp học của tôi',
    LAST_ACCESS_DATE: 'Hạn cuối truy cập khóa học',
    TAKE_FINAL_EXAM: 'Làm bài kiểm tra cuối khóa',
    HOMEWORK: 'Bài tập về nhà',
    COURSE_DISCUSSION: 'Thảo luận của giảng viên',
    DISCUSSION: 'Thảo luận',
    VIEW_ALL: 'Xem tất cả',
    NO_TOPIC: 'Không có bài viết',
    CLASS_PROHIBITED:
      'Rất tiếc, bạn không thể truy cập vào khóa học này. Xin vui lòng kiểm tra lại thông tin thanh toán của bạn đối với khóa học.',
    FREE_COURSES: 'Khóa học miễn phí',
    TRY_FREE: 'Học thử miễn phí',
    NO_COURSES_YET: 'Bạn chưa tham gia lớp học nào',
    SEARCH_PLACEHOLDER: 'Tìm kiếm theo tên khóa học...',
    NO_COURSES_MATCH_SEARCH: 'Không tìm thấy khóa học phù hợp',
    CLEAR_SEARCH: 'Xóa tìm kiếm',
    GET_STARTED: 'Hãy nhận tư vấn để bắt đầu học tập',
    NO_FREE_COURSES: 'Hiện tại chưa có khóa học miễn phí nào',
    DURATION: 'Thời hạn',
    MONTH: 'tháng',
    MAX_PROJECT_SUBMISSION: {
      TEXT_1: 'Mỗi đồ án cuối khóa có thể nộp tối đa',
      TEXT_2: 'lần. Bạn còn',
      TEXT_3: 'lần nữa',
      TEXT_4: 'Bạn đã vượt quá số lần nộp tối đa',
      TEXT_5: 'lần',
      TEXT_6: 'Vui lòng liên hệ giáo viên để được hỗ trợ',
    },
    FINAL_PROJECT: {
      TEXT_1: 'Nộp đồ án cuối khóa',
      TEXT_2: 'Vui lòng cung cấp link github repository của đồ án cuối khóa.',
      TEXT_3: 'Đảm bảo repository của bạn là public hoặc bạn đã cấp quyền truy cập cho giảng viên khóa học.',
    },
  },
  COURSE_UI: {
    OVERVIEW: 'Tổng quan',
    LESSON: 'Bài học',
    LESSONS_COUNT: (count: number) => `${count} bài học`,
    NO_DESCRIPTION: 'Chưa có mô tả khóa học',
    NO_LESSONS: 'Chưa có bài học nào',
    EDIT_COURSE: 'Chỉnh sửa khóa học',
    VIEW_RESOURCE: 'Xem tài nguyên',
    QUESTION_OF: (current: number, total: number) => `Câu hỏi ${current} / ${total}`,
    NEW_ATTEMPT: 'Làm lại',
    SUBMIT_QUIZ: 'Nộp bài',
    SUBMIT_ASSIGNMENT: 'Nộp bài tập',
    RETRY_ASSIGNMENT: 'Thử lại',
    SUBMITTING: 'Đang nộp...',
    QUIZ_SUBMITTED: 'Nộp bài thành công!',
    ASSIGNMENT_SUBMITTED: 'Nộp bài tập thành công!',
    PASSED: 'ĐẠT',
    FAILED: 'CHƯA ĐẠT',
    SHOW_EXPLANATIONS: 'Xem giải thích',
    QUIZ_EXPLANATIONS: 'Giải thích bài quiz',
    YOUR_CORRECT_ANSWERS: 'Câu trả lời đúng của bạn:',
    YOUR_WRONG_ANSWERS: 'Câu trả lời sai của bạn:',
    EXPLANATION: 'Giải thích',
    OPEN_EXPLANATION: 'Mở',
    NO_EXPLANATION: 'Chưa có giải thích.',
    NO_QUIZ_QUESTIONS: 'Không có câu hỏi cho bài quiz này',
    OVERDUE_BY: 'Quá hạn',
    TIME_REMAINING: 'Thời gian còn lại',
    DUE_AT: 'Hạn nộp:',
    DOWNLOAD_ASSIGNMENT: 'Tải bài tập',
    GRADER_FILES: 'File chấm điểm:',
    GRADER_FILE: (n: number) => `File chấm điểm ${n}`,
    NO_ASSIGNMENT_CONTENT: 'Không có nội dung cho bài tập này.',
    NO_TEXT_CONTENT: 'Không có nội dung cho tài liệu này.',
    NO_VIDEO: 'Khóa học này chưa có video',
    SELECT_LESSON: 'Chọn một bài học để bắt đầu xem',
    VIDEO_URL_UNAVAILABLE: 'Video của bài học này chưa có sẵn',
    PREMIUM_LESSON:
      'Bài học này thuộc khóa học trả phí. Đăng ký ngay để truy cập toàn bộ nội dung, thảo luận và tài nguyên.',
    PREMIUM_CONTENT: 'Nội dung trả phí',
    ENROLL_NOW: 'Đăng ký ngay - $99',
    ADMIN_ACCESS: 'Quyền quản trị',
    ADMIN_ACCESS_DESC: 'Bạn có toàn quyền truy cập nội dung khóa học với tư cách quản trị viên.',
    MARK_VIDEO_FAILED: 'Không thể đánh dấu video đã hoàn thành. Vui lòng thử lại.',
    MARK_LESSON_FAILED: 'Không thể đánh dấu bài học đã hoàn thành. Vui lòng thử lại.',
    MARK_QUIZ_FAILED: 'Không thể đánh dấu quiz đã hoàn thành. Vui lòng thử lại.',
    SUBMIT_QUIZ_FAILED: 'Không thể nộp bài quiz. Vui lòng thử lại.',
    FULLSCREEN_FAILED: 'Không thể bật/tắt chế độ toàn màn hình.',
    DOWNLOAD_FAILED: 'Không thể tải bài tập. Vui lòng thử lại.',
    QUIZ_PASS_TOAST: (score: number, passingScore: number) =>
      `🎉 Chúc mừng! Bạn đạt ${score}% và đã vượt qua! (Điểm đạt: ${passingScore}%)`,
    QUIZ_FAIL_TOAST: (score: number, passingScore: number) =>
      `Bạn đạt ${score}%. Cần ${passingScore}% để vượt qua. Hãy xem lại và thử lại.`,
    QUIZ_ANSWERED: (correct: number, total: number) =>
      `Bạn trả lời đúng ${correct} / ${total} câu hỏi.`,
    PASSING_SCORE_REQUIRED: 'Điểm đạt yêu cầu:',
    MORE_CORRECT_NEEDED: (count: number) => ` (Bạn cần thêm ${count} câu đúng)`,
    QUIZ_PASS_HINT: '🎉 Chúc mừng! Bạn có thể xem lại các đáp án đúng được tô xanh bên dưới.',
    QUIZ_FAIL_HINT: '📚 Hãy xem giải thích bên dưới để hiểu đáp án đúng và thử lại.',
    BACK_TO_RESULTS: 'Quay lại kết quả',
    DELETE_SELECTED: (count: number) => `Xóa (${count})`,
    VIEW_COURSE_TITLE: 'Xem khóa học',
    VIEW_COURSE_SUBTITLE: 'Xem nội dung, bài học và thảo luận của khóa học',
    BACK_TO_COURSES: 'Quay lại danh sách khóa học',
    BACK_TO_COURSE: 'Quay lại khóa học',
    CREATE_COURSE: 'Tạo khóa học mới',
    EDIT_COURSE_TITLE: 'Chỉnh sửa khóa học',
    CREATE_COURSE_SUBTITLE: 'Thiết lập khóa học mới và các module',
    EDIT_COURSE_SUBTITLE: 'Cập nhật thông tin và nội dung học tập',
    SETUP_LESSON: 'Thiết lập bài học',
    SETUP_LESSON_SUBTITLE: 'Cấu hình nội dung và tài liệu bài học',
    ADD_MODULE: 'Thêm module',
    ADD_LESSON: 'Thêm bài học',
    DELETE_MODULE: 'Xóa module',
    DELETE: 'Xóa',
    SAVE_CHANGES: 'Lưu thay đổi',
    SAVING: 'Đang lưu...',
    COURSE_INFORMATION: 'Thông tin khóa học',
    NAME_OF_COURSE: 'Tên khóa học',
    ENTER_COURSE_NAME: 'Nhập tên khóa học',
    DESCRIPTION: 'Mô tả',
    SETTING: 'Cài đặt',
    PUBLISH_COURSE: 'Xuất bản khóa học',
    FREE_COURSE: 'Khóa học miễn phí',
    NAME_OF_MODULE: 'Tên module',
    ENTER_MODULE_NAME: 'Nhập tên module',
    NO_LESSONS_YET: 'Chưa có bài học. Dùng "Thêm bài học" để tạo bài đầu tiên.',
    NO_MODULES_YET: 'Chưa có module. Dùng "Thêm module" để cấu trúc khóa học.',
    DELETE_MODULE_TITLE: 'Xóa module này?',
    DELETE_LESSON_TITLE: 'Xóa bài học này?',
    DELETE_CONTENT_TITLE: 'Xóa nội dung này?',
    DELETE_QUESTION_TITLE: 'Xóa câu hỏi này?',
    DELETE_ANSWER_TITLE: 'Xóa đáp án này?',
    DELETE_ATTACHMENT_TITLE: 'Xóa tệp đính kèm này?',
    DELETE_CONFIRM_DESC: (label: string) =>
      `${label} và mọi nội dung bên trong sẽ bị xóa.\nHành động này không thể hoàn tác`,
    DELETED: 'Đã xóa thành công',
    DELETE_FAILED: 'Xóa thất bại',
    ADD_CONTENT: 'Thêm nội dung',
    LESSON_INFORMATION: 'Thông tin bài học',
    NAME_OF_LESSON: 'Tên bài học',
    ENTER_LESSON_NAME: 'Nhập tên bài học',
    NO_CONTENT_YET: 'Chưa có nội dung. Chọn "Thêm nội dung" để thêm video, văn bản hoặc bài tập.',
    CONTENT_KIND_VIDEO: 'Video',
    CONTENT_KIND_TEXT: 'Văn bản',
    CONTENT_KIND_ASSIGNMENT: 'Bài tập',
    CONTENT_KIND_QUIZ: 'Quiz',
    NAME_OF_VIDEO: 'Tên video',
    ENTER_VIDEO_NAME: 'Nhập tên video',
    VIDEO_LENGTH: 'Độ dài video',
    VIDEO_LENGTH_PLACEHOLDER: '00:00:00 (hh:mm:ss)',
    NAME_OF_TEXT: 'Tên văn bản',
    ENTER_TEXT_NAME: 'Nhập tên văn bản',
    NAME_OF_ASSIGNMENT: 'Tên bài tập',
    ENTER_ASSIGNMENT_NAME: 'Nhập tên bài tập',
    NAME_OF_QUIZ: 'Tên quiz',
    ENTER_QUIZ_NAME: 'Nhập tên quiz',
    DELETE_ITEM_ARIA: (label: string) => `Xóa ${label}`,
    PUBLISH_ITEM_ARIA: (label: string) => `Xuất bản ${label}`,
    UNTITLED: 'Chưa đặt tên',
    ATTACHMENT_LINK: 'Liên kết',
    ATTACHMENT_DOCUMENT: 'Tài liệu',
    ADD_ATTACHMENT: 'Thêm tệp đính kèm',
    NAME_OF_DOCUMENT: 'Tên tài liệu',
    ENTER_DOCUMENT_NAME: 'Nhập tên tài liệu',
    ENTER_LINK_URL: 'Nhập URL liên kết',
    NAME_OF_LINK: 'Tên liên kết',
    OPTIONAL: '(Tùy chọn)',
    ENTER_LINK_NAME: 'Nhập tên liên kết',
    SELECT_RESOURCE: 'Chọn tài nguyên',
    ADD_QUESTION: 'Thêm câu hỏi',
    QUESTION_N: (n: number) => `Câu hỏi ${n}`,
    ENTER_QUESTION: 'Nhập câu hỏi',
    DELETE_QUESTION_ARIA: (n: number) => `Xóa câu hỏi ${n}`,
    MULTIPLE_CHOICE: 'Nhiều đáp án',
    ANSWER_COUNT: (n: number) => `Đáp án (${n})`,
    ADD_ANSWER: 'Thêm đáp án',
    ANSWER_N: (n: number) => `Đáp án ${n}`,
    ENTER_ANSWER: 'Nhập đáp án',
    ANSWER_CORRECT_ARIA: (n: number) => `Đáp án ${n} là đúng`,
    DELETE_ANSWER_ARIA: (n: number) => `Xóa đáp án ${n}`,
    EXPLANATION_OPTIONAL: 'Giải thích (Tùy chọn)',
    COURSE_TITLE_REQUIRED: 'Vui lòng nhập tên khóa học',
    CHECK_COURSE_INFO: 'Vui lòng kiểm tra thông tin khóa học',
    UPLOAD_IN_PROGRESS: 'Đang tải lên',
    UPLOAD_WAIT: 'Vui lòng đợi đến khi mọi video tải lên xong.',
    CHECK_COURSE_CONTENT: 'Vui lòng kiểm tra nội dung khóa học',
    COURSE_UPDATED: 'Cập nhật khóa học thành công',
    COURSE_CREATED: 'Tạo khóa học thành công',
    UPDATE_COURSE_FAILED: 'Cập nhật khóa học thất bại',
    CREATE_COURSE_FAILED: 'Tạo khóa học thất bại',
    SOMETHING_WENT_WRONG: 'Đã xảy ra lỗi',
    MANAGE_STUDENTS: 'Quản lý học viên',
    MANAGE_STUDENTS_SUBTITLE: 'Quản lý và tổ chức khóa học trên nền tảng',
    SELECT_STUDENTS: 'Chọn học viên',
    ADD_STUDENTS: 'Thêm học viên',
    SEARCHING: 'Đang tìm...',
    SEARCH_PLACEHOLDER: 'Tìm kiếm...',
    SELECT_ALL_STUDENTS: 'Chọn tất cả học viên trên trang này',
    NAME: 'Tên',
    EMAIL: 'Email',
    QUIZ_PROGRESS: 'Tiến độ quiz',
    DISCUSSION_COL: 'Thảo luận',
    CERTIFIED: 'Chứng chỉ',
    ACTIONS: 'Thao tác',
    LOADING_STUDENTS: 'Đang tải học viên...',
    EMPTY_STUDENTS: 'Thêm học viên mới hoặc điều chỉnh tìm kiếm và bộ lọc',
    YES: 'Có',
    NO: 'Không',
    ALL: 'Tất cả',
    VIEW_DETAIL: 'Xem chi tiết',
    REMOVE_STUDENT_TITLE: 'Xóa học viên này khỏi khóa học?',
    REMOVE_STUDENTS_TITLE: (count: number) => `Xóa ${count} học viên khỏi khóa học?`,
    REMOVE_STUDENT_DESC: 'Học viên này sẽ bị xóa khỏi khóa học.\nBạn có thể thêm lại sau.',
    REMOVE_STUDENTS_DESC: 'Các học viên này sẽ bị xóa khỏi khóa học.\nBạn có thể thêm lại sau.',
    CONFIRM: 'Xác nhận',
    REMOVING: 'Đang xóa...',
    STUDENTS_REMOVED: 'Đã xóa học viên',
    STUDENTS_REMOVED_DESC: 'Các học viên đã chọn đã được xóa khỏi khóa học.',
    COULD_NOT_REMOVE: 'Không thể xóa học viên',
    TRY_AGAIN: 'Đã xảy ra lỗi. Vui lòng thử lại.',
    STUDENTS_ADDED: 'Đã thêm học viên',
    STUDENTS_ADDED_DESC: 'Danh sách học viên của khóa học đã được cập nhật.',
    COULD_NOT_ADD: 'Không thể thêm học viên',
    NO_STUDENTS_SELECTED: 'Chưa chọn học viên',
    SELECT_AT_LEAST_ONE: 'Tìm kiếm và chọn ít nhất một học viên.',
    SEARCH_STUDENTS_PLACEHOLDER: 'Tìm theo tên hoặc email học viên...',
    NO_MATCHING_STUDENTS: 'Không tìm thấy học viên phù hợp.',
    ADDING: 'Đang thêm...',
    ADD_COUNT: (count: number) => `Thêm (${count})`,
    CLOSE: 'Đóng',
    STUDENT_REPORT: 'Báo cáo học viên',
    STUDENT_REPORT_NAMED: (name: string) => `Báo cáo học viên: ${name}`,
    LOADING_STUDENT_REPORT: 'Đang tải báo cáo học viên...',
    UNABLE_LOAD_STUDENT_REPORT: 'Không thể tải báo cáo học viên.',
    ATTENDANCE: 'Điểm danh',
    DISCUSSIONS_MADE: (count: number) => `Số thảo luận trong khóa học: ${count}`,
    QUIZ_SCORING: 'Điểm quiz',
    AVERAGE_SCORE: (score: string) => `Điểm trung bình: ${score}`,
    MARK_CERTIFIED: 'Đánh dấu đã cấp chứng chỉ',
    VIEW_CERTIFICATE: 'Xem chứng chỉ',
    REPORT_UPDATED: 'Đã cập nhật báo cáo học viên',
    REPORT_UPDATED_DESC: 'Trạng thái chứng chỉ đã được lưu.',
    REPORT_UPDATE_ERROR: 'Có lỗi khi cập nhật báo cáo học viên',
    ERROR: 'Lỗi',
    DISCUSSION_SUBTITLE: 'Chia sẻ câu hỏi và ý tưởng với bạn học',
    NEW_DISCUSSION: 'Thảo luận mới',
    CREATE_TOPIC_ARIA: 'Tạo chủ đề thảo luận mới',
    DELETE_TOPIC: 'Xóa bài viết',
    DELETE_TOPIC_WARN: 'Hành động này không thể hoàn tác. Bài viết và mọi bình luận sẽ bị xóa vĩnh viễn.',
    DELETE_TOPIC_CONFIRM:
      'Bạn có chắc muốn xóa bài viết này? Hành động này không thể hoàn tác và sẽ xóa vĩnh viễn bài viết cùng mọi bình luận.',
    DELETING: 'Đang xóa...',
    DELETE_TOPIC_BTN: 'Xóa bài viết',
    COMMENT: 'Bình luận',
    CREATE_POST: 'Tạo bài viết',
    EDIT_POST: 'Chỉnh sửa bài viết',
    GENERAL_DISCUSSION: 'Thảo luận chung',
    ANONYMOUS: 'Ẩn danh',
    SIGN_IN_TO_REACT: 'Đăng nhập để bày tỏ cảm xúc',
  },
  SETTING_BAR: {
    MY_COURSE: 'Lớp của tôi',
    PROFILE: 'Thông tin cá nhân',
    CHANGE_PASSWORD: 'Cập nhật mật khẩu',
    COURSE_MANAGEMENT: 'Quản lý khóa học',
    CLASS_MANAGEMENT: 'Quản lý lớp học',
    USER_MANAGEMENT: 'Quản lý người dùng',
    SANDBOX_MANAGEMENT: 'Quản lý sandbox',
    VOUCHER_MANAGEMENT: 'Quản lý vouchers',
    BLOG_MANAGEMENT: 'Quản lý bài viết',
    RESOURCE_MANGEMENT: 'Quản lý tài nguyên',
    HALL_OF_FAME: 'Quản lý dự án của học viên',
    LOGOUT: 'Đăng xuất',
    SURVEY_ADMIN: 'Khảo sát của người dùng',
    SURVEY: 'Khảo sát',
    WEBINARS_MANAGEMENT: 'Quản lý webinars',
    BILLING: 'Thanh toán',
    COMPANY_MANAGEMENT: 'Quản lý công ty',
    JOBS: 'Quản lý tuyển dụng',
    REFERRED_USERS: 'Người dùng được giới thiệu',
    POINTS: 'Điểm thưởng',
    MANAGEMENT: 'Quản lý',
    ADMIN_DASHBOARD: 'Trang quản trị',
  },
  NAV: {
    COURSES: 'Khóa học',
    ONLINE_TESTS: 'Bài kiểm tra trực tuyến',
    AI_GENERATED_CONTENT: 'Nội dung AI',
    EXAMPLE_PRACTICES: 'Bài mẫu',
    USERS: 'Người dùng',
    SANDBOX: 'Sandbox',
    BLOGS: 'Blog',
    WEBINARS: 'Webinars',
    RESOURCES: 'Tài nguyên',
    CERTIFICATE_CONFIG: 'Chứng chỉ',
    HALL_OF_FAME: 'Hall of Fame',
    SURVEYS: 'Khảo sát',
    VOUCHERS: 'Vouchers',
    JOBS: 'Tuyển dụng',
    COMPANIES: 'Công ty tuyển dụng',
    ANNOUNCEMENTS: 'Thông báo',
    EMOJI: 'Emoji',
    CREDIT_POINTS: 'Điểm thưởng',
    NOTIFICATION_CONFIG: 'Cấu hình thông báo',
    SETTINGS: 'Cài đặt',
    SUPPORT: 'Hỗ trợ',
    BLOG_MANAGEMENT: 'Quản lý bài viết',
  },
  ADMIN: {
    COURSES_TITLE: 'Khóa học',
    COURSES_DESC: 'Quản lý và tổ chức khóa học trên nền tảng',
    COURSES_SEO: 'Quản trị khóa học',
    USERS_TITLE: 'Người dùng',
    USERS_DESC: 'Xem và quản lý người dùng trên nền tảng',
    USERS_SEO: 'Quản trị người dùng',
    WEBINARS_TITLE: 'Webinars',
    WEBINARS_DESC: 'Xem và quản lý webinars trên nền tảng',
    WEBINARS_SEO: 'Quản trị webinars',
    HALL_OF_FAME_TITLE: 'Hall of Fame',
    HALL_OF_FAME_DESC: 'Xem và quản lý dự án của học viên',
    HALL_OF_FAME_SEO: 'Quản trị Hall of Fame',
    SURVEYS_TITLE: 'Khảo sát',
    SURVEYS_DESC: 'Xem phản hồi khảo sát trên nền tảng',
    SURVEYS_SEO: 'Quản trị khảo sát',
    VOUCHERS_TITLE: 'Vouchers',
    VOUCHERS_DESC: 'Xem và quản lý vouchers trên nền tảng',
    VOUCHERS_SEO: 'Quản lý vouchers',
    COMPANIES_TITLE: 'Công ty',
    COMPANIES_DESC: 'Xem và quản lý công ty trên nền tảng',
    COMPANIES_SEO: 'Quản lý công ty',
    JOBS_TITLE: 'Tuyển dụng',
    JOBS_DESC: 'Xem và quản lý tin tuyển dụng trên nền tảng',
    JOBS_SEO: 'Quản lý tuyển dụng',
    ANNOUNCEMENTS_TITLE: 'Thông báo',
    ANNOUNCEMENTS_DESC: 'Gửi thông báo web hoặc email cho tất cả người dùng, theo vai trò hoặc theo lớp',
    ANNOUNCEMENTS_SEO: 'Quản trị thông báo',
    AI_CONTENT_TITLE: 'Nội dung AI',
    AI_CONTENT_DESC: 'Trung tâm slides và tài liệu được tạo tự động',
    AI_CONTENT_SEO: 'Nội dung AI',
    RESOURCES_TITLE: 'Tài nguyên',
    RESOURCES_DESC: 'Tải lên và tổ chức tài nguyên học tập',
    RESOURCES_SEO: 'Quản lý tài nguyên',
    SANDBOXES_TITLE: 'Sandbox',
    SANDBOXES_DESC: 'Xem và quản lý sandbox trên nền tảng',
    SANDBOXES_SEO: 'Quản trị sandbox',
    CREDIT_POINTS_TITLE: 'Điểm thưởng',
    CREDIT_POINTS_DESC: 'Xem và quản lý điểm thưởng trên nền tảng',
    CREDIT_POINTS_SEO: 'Điểm thưởng',
    CREDIT_POINTS_ANALYTICS_TITLE: 'Phân tích điểm thưởng',
    CREDIT_POINTS_ANALYTICS_DESC: 'Xem tổng quan, top người dùng và lịch sử đổi điểm',
    MEDIA_DEFAULTS_TITLE: 'Media mặc định',
    MEDIA_DEFAULTS_DESC:
      'Xem và quản lý branding cộng đồng, media, liên kết mạng xã hội và email mặc định',
    MEDIA_DEFAULTS_SEO: 'Media mặc định',
    EMOJI_TITLE: 'Emoji',
    EMOJI_DESC: 'Quản lý emoji tùy chỉnh cho nền tảng',
    EMOJI_SEO: 'Quản trị emoji',
    CERTIFICATE_TITLE: 'Chứng chỉ',
    CERTIFICATE_DESC: 'Cấu hình mẫu chứng chỉ cho cộng đồng',
    CERTIFICATE_SEO: 'Cấu hình chứng chỉ',
    NOTIFICATION_CONFIG_TITLE: 'Cấu hình thông báo',
    NOTIFICATION_CONFIG_DESC: 'Cấu hình mẫu và kênh thông báo',
    NOTIFICATION_CONFIG_SEO: 'Cấu hình thông báo',
    ONLINE_TESTS_TITLE: 'Bài kiểm tra trực tuyến',
    ONLINE_TESTS_DESC: 'Tạo và quản lý bài kiểm tra trực tuyến',
    ONLINE_TESTS_SEO: 'Quản trị bài kiểm tra',
    EXAMPLE_PRACTICES_TITLE: 'Bài mẫu',
    EXAMPLE_PRACTICES_DESC: 'Quản lý các bài mẫu thực hành',
    EXAMPLE_PRACTICES_SEO: 'Quản trị bài mẫu',
    BLOGS_TITLE: 'Blog',
    BLOGS_DESC: 'Xem và quản lý blog trên nền tảng',
    BLOGS_SEO: 'Quản trị blog',
    ALL: 'Tất cả',
    PUBLISH: 'Xuất bản',
    DRAFT: 'Nháp',
    MESSAGES: 'Tin nhắn',
    EXPAND_SIDEBAR: 'Mở rộng thanh bên',
    COLLAPSE_SIDEBAR: 'Thu gọn thanh bên',
    RESIZE_SIDEBAR: 'Đổi kích thước thanh bên',
    DRAG_TO_RESIZE: 'Kéo để đổi kích thước',
    OPEN_MENU: 'Mở menu',
    SEARCHING: 'Đang tìm...',
    TITLE: 'Tiêu đề',
    UPLOAD_DATE: 'Ngày tải lên',
    DOWNLOAD: 'Tải xuống',
    ACTIONS: 'Thao tác',
    NO_DATA: 'Không có dữ liệu',
    UPLOAD_OR_CREATE_FOLDER: 'Tải file lên hoặc tạo thư mục để bắt đầu',
    ADJUST_SEARCH_OR_FOLDER: 'Thử điều chỉnh tìm kiếm hoặc mở thư mục khác',
    CREATE_COURSE_TO_UPLOAD: 'Vui lòng tạo khóa học để bắt đầu tải dữ liệu lên',
    ALLOWED: 'Cho phép',
    RESTRICTED: 'Hạn chế',
    DELETE_RESOURCE_TITLE: 'Xóa tài nguyên này?',
    DELETE_RESOURCE_DESC: 'Tài nguyên sẽ bị xóa vĩnh viễn.\nHành động này không thể hoàn tác',
    RESOURCE_DELETED: 'Đã xóa tài nguyên thành công',
    DELETE_FAILED: 'Xóa thất bại',
    COPY_SUCCESS: 'Sao chép thành công',
    COPY_FAILED: 'Sao chép thất bại',
    COPY_FAILED_DESC: 'Không thể sao chép liên kết. Vui lòng thử lại.',
    TRY_ADJUST_SEARCH: 'Thử điều chỉnh tìm kiếm',
    CREATE_USER: 'Tạo người dùng mới',
    USER_DETAIL: 'Chi tiết người dùng',
    USER_DETAIL_SUBTITLE: 'Xem và quản lý người dùng trên nền tảng',
    BACK_TO_USERS: 'Quay lại danh sách người dùng',
  },
  PRICING: {
    TITLE: 'Bảng giá',
    SUBTITLE: 'Chọn gói phù hợp cho hành trình của bạn',
    ANNUAL: 'Hàng năm',
    STUDENT_PLAN: {
      TITLE: 'Gói Sinh viên',
      PRICE: '£39',
      DESCRIPTION: 'Mọi thứ bạn cần để xuất sắc trong học tập và nghiên cứu',
      FEATURES: {
        UNLIMITED_ACCESS: 'Truy cập không giới hạn tất cả tài nguyên',
        RESEARCH_TOOLS: 'Công cụ nghiên cứu nâng cao',
        COLLABORATION: 'Tính năng cộng tác',
        PRIORITY_SUPPORT: 'Hỗ trợ ưu tiên',
        UPDATES: 'Cập nhật thường xuyên và nội dung mới',
        MOBILE_ACCESS: 'Truy cập qua ứng dụng di động',
      },
    },
  },
  HALL_OF_FAME: {
    DESCRIPTION:
      'Nền tảng ghi dấu bước tiến của học viên, nơi lưu giữ những thành quả đáng tự hào, offers hấp dẫn và đồ án tâm huyết.',
    ALL: 'Tất cả',
    FILTER_BY: 'Lọc theo',
    NO_PROJECT_FOUND: 'Không tìm thấy dự án nào',
    NO_PROJECT_FOUND_TEXT_1: 'Không có dự án nào trong danh mục [Index]. Vui lòng thử chọn danh mục khác.',
    NO_PROJECT_FOUND_TEXT_2: 'Hiện tại chưa có dự án nào được thêm vào. Vui lòng quay lại sau.',
    VIEW_DETAILS: 'Xem chi tiết',
  },
  BLOG: {
    TITLE: 'Blog',
    DESCRIPTION: 'Luôn cập nhật những tin tức, xu hướng công nghệ mới nhất, kiến thức chuyên sâu và các bài giảng chất lượng.',
  },
  RESOURCE: {
    ERROR: 'Bạn không thể truy cập tài nguyên này',
    HEADING: 'Quản lý tài nguyên',
    UPLOAD: 'Tải lên',
    CREATE_FOLDER: 'Tạo thư mục',
  },
  TABLE: {
    TOTAL: 'Tổng số',
    ALL: 'Tất cả',
  },
  COMMON: {
    HOME: 'Trang chủ',
    LOADING: 'Đang tải...',
    CANCEL: 'Hủy',
    DETAILS: 'Chi tiết',
    START: 'Bắt đầu',
    REVIEW: 'Xem lại',
    BREADCRUMB: 'Đường dẫn',
    MINUTES: 'phút',
    MINUTES_SHORT: 'phút',
    NO_DESCRIPTION: 'Chưa có mô tả.',
    OF: 'trên',
    SAVE: 'Lưu',
    DELETE: 'Xóa',
    CLOSE: 'Đóng',
    CONFIRM: 'Xác nhận',
    YES: 'Có',
    NO: 'Không',
    SEARCH: 'Tìm kiếm',
  },
  ONLINE_TEST: {
    TITLE: 'Bài kiểm tra trực tuyến',
    SUBTITLE: 'Duyệt bài kiểm tra công khai hoặc xem các bài được giao cho bạn.',
    PUBLIC_TAB: 'Công khai',
    MY_TESTS_TAB: 'Bài của tôi',
    PUBLIC_BADGE: 'Công khai',
    PUBLIC_EMPTY_TITLE: 'Chưa có bài kiểm tra công khai',
    PUBLIC_EMPTY_DESCRIPTION: 'Các bài kiểm tra công khai đã xuất bản sẽ hiển thị tại đây để mọi người có thể khám phá và làm bài.',
    TAKE_TEST: 'Làm bài',
    PUBLIC_SIGN_IN_TITLE: 'Đăng nhập để làm bài',
    PUBLIC_SIGN_IN_DESCRIPTION: 'Bạn cần đăng nhập để bắt đầu làm bài kiểm tra này.',
    MY_TESTS_SIGN_IN_TITLE: 'Đăng nhập để xem bài được giao',
    MY_TESTS_SIGN_IN_DESCRIPTION: 'Các bài kiểm tra được giảng viên giao sẽ hiển thị tại đây sau khi bạn đăng nhập.',
    UNABLE_TO_LOAD: 'Không thể tải danh sách bài kiểm tra.',
    UNABLE_TO_START: 'Không thể bắt đầu bài kiểm tra',
    UNABLE_TO_SUBMIT: 'Không thể nộp bài kiểm tra',
    UNABLE_TO_LOAD_ATTEMPT: 'Không thể tải lượt làm bài.',
    UNABLE_TO_LOAD_REVIEW: 'Không thể tải kết quả xem lại.',
    TEST_UNAVAILABLE: 'Bài kiểm tra không khả dụng',
    TEST_NOT_AVAILABLE: 'Bài kiểm tra không khả dụng',
    TEST_UNAVAILABLE_HINT: 'Nếu bạn cho rằng đây là lỗi, vui lòng liên hệ giảng viên hoặc quản trị viên.',
    BACK_TO_MY_TESTS: 'Quay lại danh sách bài kiểm tra',
    BACK_TO_TEST: 'Quay lại bài kiểm tra',
    ATTEMPT_UNAVAILABLE: 'Lượt làm bài không khả dụng',
    UNABLE_TO_LOAD_ATTEMPT_TITLE: 'Không thể tải lượt làm bài',
    REVIEW_UNAVAILABLE: 'Không thể xem lại kết quả',
    UNABLE_TO_LOAD_REVIEW_TITLE: 'Không thể tải kết quả xem lại',
    NO_ACCESS: 'Bạn không có quyền truy cập bài kiểm tra này.',
    LOAD_ERROR: 'Đã xảy ra lỗi khi tải bài kiểm tra.',
    UNLIMITED_ATTEMPTS: 'Không giới hạn lượt làm',
    NO_ATTEMPTS_LEFT: 'Hết lượt làm bài',
    ATTEMPTS_LEFT: (remaining: number, limit: number) => `Còn ${remaining}/${limit} lượt`,
    EMPTY_TITLE: 'Chưa có bài kiểm tra nào được giao',
    EMPTY_DESCRIPTION:
      'Khi giảng viên giao bài kiểm tra trực tuyến, bài sẽ hiển thị tại đây. Vui lòng quay lại sau hoặc liên hệ giảng viên.',
    TIME_LIMIT: 'Thời gian làm bài',
    CONTENT: 'Nội dung',
    OPEN_TOC: 'Mục lục',
    PASSING_SCORE: 'Điểm đạt',
    ATTEMPTS: 'Lượt làm bài',
    UNLIMITED: 'Không giới hạn',
    ATTEMPTS_USED: (completed: number, limit: number) => `Đã dùng ${completed}/${limit}`,
    ALL_ATTEMPTS_USED: 'Đã hết lượt làm bài',
    ALL_ATTEMPTS_USED_DESC: (limit: number) =>
      `Bạn đã hoàn thành tất cả ${limit} lượt làm bài được phép. Xem kết quả bên dưới.`,
    STARTING: 'Đang bắt đầu…',
    NO_ATTEMPTS_REMAINING: 'Không còn lượt làm bài',
    START_NEW_ATTEMPT: 'Bắt đầu lượt mới',
    START_NOW: 'Bắt đầu ngay',
    ATTEMPT_HISTORY: 'Lịch sử làm bài',
    NO_ATTEMPTS_YET: 'Chưa có lượt làm bài',
    NO_ATTEMPTS_YET_DESC: 'Bắt đầu lượt đầu tiên để xem kết quả tại đây.',
    START_TEST_TITLE: 'Bắt đầu bài kiểm tra?',
    START_TEST_INTRO: (title: string) => `Bạn sắp bắt đầu ${title}. Vui lòng xem lại điều kiện làm bài:`,
    START_TEST_TIME_LIMIT: (minutes: number) => `Thời gian: ${minutes} phút`,
    START_TEST_PASSING_SCORE: (score: string) => `Điểm đạt: ${score}`,
    START_TEST_ATTEMPT: (current: number, limit?: number) =>
      limit ? `Lượt làm: ${current}/${limit}` : `Lượt làm: ${current}`,
    START_TEST_TAB_WARNING: 'Chuyển tab có thể bị ghi nhận là vi phạm',
    START_TEST_TIMER_NOTE:
      'Đồng hồ bắt đầu ngay lập tức. Hãy đảm bảo kết nối ổn định và bạn có thể hoàn thành bài kiểm tra mà không bị gián đoạn.',
    ACCESS_AVAILABLE: 'Đang mở',
    ACCESS_CLOSED: 'Đã đóng',
    ACCESS_FROM: (date: string) => `Mở từ ${date}`,
    SCORE: 'Điểm',
    INTEGRITY_VIOLATION: 'Vi phạm quy chế',
    IN_PROGRESS_RESUME: 'Đang làm — nhấn để tiếp tục',
    PASS: 'Đạt',
    FAIL: 'Không đạt',
    IN_PROGRESS: 'Đang làm',
    REVIEW_TITLE_SUFFIX: 'Xem lại',
    REVIEW_SEO_TITLE: (title: string) => `Xem lại ${title}`,
    PROCTORING_FAILED_TITLE: 'Lượt làm bài không đạt do vi phạm quy chế.',
    PROCTORING_FAILED_DESC: (count: number, limit: number) => `Số lần vi phạm: ${count}/${limit}.`,
    QUESTION_REVIEW: 'Xem lại câu hỏi',
    QUESTIONS_CORRECT: (correct: number, total: number) => `${correct}/${total} câu trả lời đúng`,
    QUESTION_PAGES: 'Trang câu hỏi',
    PAGE_RANGE: (page: number, start: number, end: number) => `Trang ${page}: Câu ${start}–${end}`,
    SHOWING_QUESTIONS: (start: number, end: number, total: number) =>
      `Hiển thị câu ${start}–${end} trên ${total}`,
    CORRECT: 'Đúng',
    SELECTED: 'Đã chọn',
    YOUR_ANSWER: 'Câu trả lời của bạn',
    CORRECT_ANSWER: 'Đáp án đúng',
    SLOT_NOT_ANSWERED: 'Chưa trả lời',
    YOUR_CORRECT_ANSWERS: 'Câu trả lời đúng của bạn:',
    YOUR_WRONG_ANSWERS: 'Câu trả lời sai của bạn:',
    NO_ANSWER_SELECTED: 'Bạn chưa trả lời câu hỏi này',
    EXPLANATION: 'Giải thích',
    NAV_PENDING_COUNT: (count: number) => `Bài kiểm tra (${count})`,
    TAB_SWITCH_TITLE: 'Đã ghi nhận chuyển tab',
    TAB_SWITCH_DESC: (warning: number, limit: number) =>
      `Cảnh báo ${warning}/${limit}. Rời khỏi tab bài kiểm tra lần nữa sẽ tự động nộp bài và tính là không đạt.`,
    TEST_SUBMITTED_TITLE: 'Đã nộp bài',
    TEST_SUBMITTED_DESC: 'Lượt làm bài đã được nộp do vi phạm quy chế. Đang chuyển đến kết quả…',
    QUESTION_OF: (current: number, total: number) => `Câu ${current}/${total}`,
    MULTIPLE_SELECT: 'Chọn nhiều đáp án',
    SINGLE_CHOICE: 'Chọn một đáp án',
    CHOOSE_MULTIPLE: 'Chọn một hoặc nhiều đáp án',
    READING_PASSAGE: 'Bài đọc',
    DROP_OR_SELECT_ANSWER: 'Kéo hoặc chọn đáp án',
    TYPE_OR_SELECT_ANSWER: 'Nhập hoặc chọn',
    TYPE_ANSWER: 'Nhập đáp án',
    SELECT_ANSWER: 'Chọn đáp án',
    DRAG_OPTION_INTO_QUESTION: 'Kéo option vào câu hỏi',
    OPTIONS_COUNT: (count: number) => `${count} options`,
    PREVIOUS: 'Câu trước',
    NEXT: 'Câu sau',
    REVIEW_AND_SUBMIT: 'Xem lại & Nộp bài',
    QUESTIONS: 'Câu hỏi',
    ALL_QUESTIONS: 'Tất cả câu hỏi',
    ANSWERED_OF: (answered: number, total: number) => `Đã trả lời ${answered}/${total}`,
    SUBMIT: 'Nộp bài',
    DONE: 'đã xong',
    ANSWER_SAVE_FAILED: 'Lưu câu trả lời thất bại',
    ANSWER_SAVE_FAILED_DESC: 'Vui lòng thử lại trước khi nộp bài.',
    RESOLVE_SAVE_FAILURES: 'Vui lòng xử lý lỗi lưu câu trả lời trước khi nộp bài',
    SUBMIT_TEST_TITLE: 'Nộp bài kiểm tra?',
    SUBMIT_TEST_DESC: 'Xem lại tiến độ trước khi nộp. Hành động này không thể hoàn tác.',
    ANSWERED: 'Đã trả lời',
    UNANSWERED: 'Chưa trả lời',
    FLAGGED: 'Đã đánh dấu',
    REMAINING: 'Còn lại',
    UNANSWERED_QUESTIONS: 'Câu chưa trả lời:',
    MORE_UNANSWERED: (count: number) => `+${count} câu nữa`,
    CONTINUE_TEST: 'Tiếp tục làm bài',
    SUBMITTING: 'Đang nộp…',
    SUBMIT_TEST: 'Nộp bài',
    PROGRESS: 'Tiến độ',
    CURRENT: 'Hiện tại',
    UNFLAG_QUESTION: 'Bỏ đánh dấu câu hỏi',
    FLAG_FOR_REVIEW: 'Đánh dấu để xem lại',
    REVIEW_SUBMIT_LEFT: (count: number) => `Xem lại & Nộp bài (còn ${count})`,
    FAILED_INTEGRITY: 'Không đạt — Vi phạm quy chế',
    PASSED: 'Đạt',
    FAILED: 'Không đạt',
    INCORRECT: 'Sai',
    SCORE_SUMMARY: (correct: number, total: number) => `${correct}/${total} câu trả lời đúng`,
  },
  EXAMPLE_PRACTICE: {
    TITLE: 'Bài mẫu',
    DESCRIPTION:
      'Khám phá các bài viết mẫu với ví dụ chi tiết, bản dịch và bài tập hỗ trợ việc học của bạn.',
    SEO_DESCRIPTION:
      'Duyệt các bài mẫu với câu trả lời mẫu, từ vựng và bài tập.',
    SEO_SECTION: 'Bài mẫu',
    SEARCH: 'Tìm kiếm',
    SEARCH_PLACEHOLDER: 'Tìm bài viết...',
    CATEGORY: 'Danh mục',
    ALL_CATEGORIES: 'Tất cả danh mục',
    YEAR: 'Năm',
    ALL_YEARS: 'Tất cả năm',
    ORDER_BY: 'Sắp xếp theo',
    SORT_BY: 'Sắp xếp',
    NEWEST_FIRST: 'Mới nhất',
    OLDEST_FIRST: 'Cũ nhất',
    MOST_VIEWS: 'Xem nhiều nhất',
    NO_POSTS: 'Không tìm thấy bài mẫu nào.',
    MIN_READ: (minutes: number) => `${minutes} phút đọc`,
    VIEWS: (count: string) => `${count} lượt xem`,
    SHARE_DESCRIPTION: (siteName: string) => `Đọc bài mẫu này trên ${siteName}`,
    OPEN_TOC: 'Mở mục lục',
  },
  AUTH: {
    FIRST_NAME: 'Tên',
    LAST_NAME: 'Họ',
    EMAIL: 'Email',
    PASSWORD: 'Mật khẩu',
    CONFIRM_PASSWORD: 'Xác nhận mật khẩu',
    OR_CONTINUE_WITH: 'Hoặc tiếp tục với',
    CREATE_ACCOUNT: 'Tạo tài khoản',
    SIGN_UP_SUCCESS: 'Đăng ký thành công!',
    SIGN_UP_ERROR: 'Đăng ký thất bại',
    SOMETHING_WRONG: 'Đã có lỗi xảy ra.',
    USE_DIFFERENT_EMAIL: 'Dùng email khác',
  },
}

export default vi
